module.exports = __webpack_public_path__ + "img/one.f22f8feb.png";